export const fakedb = {
    luncmeets_top_5: 
        [
            {
                avatar: './assets/real_images/avatar01.png',    
                alias: 'Max',
                interest: 'Food',
                country: 'NL'    
            },
            {
                avatar: './assets/real_images/avatar02.png',
                alias: 'Justin',
                interest: 'Gym, Fashion',
                country: 'US'
            },
            {
                avatar: './assets/real_images/avatar03.png',
                alias: 'Hakeem',
                interest: 'Art',
                country: 'ID'
            },
            {
                avatar: './assets/real_images/avatar04.png',
                alias: 'Hamilton',
                interest: 'Travel',
                country: 'BR'
            },
            {
                avatar: './assets/real_images/avatar05.png',
                alias: 'Perez',
                interest: 'Music, Gym',
                country: 'MX'
            }
        ],

    marketplace_top_5: 
        [
            {
                avatar: './assets/real_images/polygon01.png',    
                alias: 'Nick',
                interest: 'UX/UI Designer',
                country: 'ID',
                description: '10+ years experience'    
            },
            {
                avatar: './assets/real_images/polygon02.png',
                alias: 'Tom',
                interest: 'Blockchain Lawyer',
                country: 'NL',
                description: 'Technology-focused lawyer I advise blockchain-centric organizations on legal compliance and systems design'
            },
            {
                avatar: './assets/real_images/polygon03.png',
                alias: 'Sofia',
                interest: 'NFT Marketing Stategist',
                country: 'US',
                description: ''
            },
            {
                avatar: './assets/real_images/polygon04.png',
                alias: 'Danny',
                interest: 'ICO marketing expert',
                country: 'MX',
                description: ''
            },
            {
                avatar: './assets/real_images/polygon05.png',
                alias: 'Vanessa',
                interest: 'Digital marketing strategist',
                country: 'BR',
                description: ''
            }
        ],
    freelance_top_5: 
        [
            {
                avatar: './assets/real_images/gig01.png',    
                title: 'Copywriter',
                created_by: 'Rubix',
                description: 'Rubix is looking for a Copywriter to write copy for a range of audiences. Must be a strong advocate for decentralization, free speech and privacy. Focusing specifically on the fulfillment of civil liberties and corporate threats to free speech, privacy online & technology.'    
            },
            {
                avatar: './assets/real_images/gig02.png',
                title: 'Rust Developer',
                created_by: 'LUNC',
                description: 'Lunc is looking for a Senior Rust / CosmWasm Developer to join our team to help build some of the most innovative applications in crypto.'
            },
            {
                avatar: './assets/real_images/gig03.png',
                title: 'Social Media Manager',
                created_by: 'Luncsphere',
                description: 'Luncsphere is looking for a skilled community manager and moderator for our social media platforms. Social platforms like Discord and Twitter are the driven spirits behind a good working project.'
            },
            {
                avatar: './assets/real_images/gig01.png',    
                title: 'Copywriter',
                created_by: 'Rubix',
                description: 'Rubix is looking for a Copywriter to write copy for a range of audiences. Must be a strong advocate for decentralization, free speech and privacy. Focusing specifically on the fulfillment of civil liberties and corporate threats to free speech, privacy online & technology.'    
            },
            {
                avatar: './assets/real_images/gig02.png',
                title: 'Rust Developer',
                created_by: 'LUNC',
                description: 'Lunc is looking for a Senior Rust / CosmWasm Developer to join our team to help build some of the most innovative applications in crypto.'
            },
        ],
    news_top_5: [
        {
            image: './assets/real_images/news01.png',
            date: 'May 26, 2023',
            title: 'Garuda Nodes will move to the new home "GARUDA UNIVERSE"',
            content: 'Please redelegate and dont delegate into Garuda Nodes🙏 because in May 31th 2023 we will close Garuda Nodes Validator'
        },
        {
            image: './assets/real_images/news02.png',
            date: 'May 26, 2023',
            title: 'Luna Classic Network',
            content: 'BREAKING NEWS! A New #UtilityNFT Series that it’s focus will be on the “Oracle Pool” will Launch “Soon” on: @miata_io - miata.io'
        },
        {
            image: './assets/real_images/news03.png',
            date: 'May 26, 2023',
            title: 'Lunc Burn Army',
            content: 'Terra Luna Classic (LUNC) core developer group Joint L1 Task Force has submitted its plan and budget for Q2.'
        },
        {
            image: './assets/real_images/news04.png',
            date: 'May 26, 2023',
            title: 'Lunc Burn Army',
            content: 'Updates for the AI app chain called Block Entropy.  Still building.  Here is a sneak peak at the white paper that is almost finished.'
        },
        {
            image: './assets/real_images/news05.png',
            date: 'May 26, 2023',
            title: 'Luncsphere',
            content: 'We have launched our new cryptomarketplace and have burned 100 million luna classic in the first month 🔥'
        }
    ],
    events_top_5: [
        {
            image: './assets/real_images/events01.png',
            date: '31st of May',
            title: 'AMA Parity Party',
            content: 'A big AMA regarding completion of parity, including lots of NFT giveaways !'
        },
        {
            image: './assets/real_images/events02.png',
            date: '25th of May',
            title: 'News Channel Launch',
            content: 'NFT series the Oracle will be launching !'
        },
        {
            image: './assets/real_images/events03.png',
            date: '4th of June',
            title: 'Garuda Universe Game Launch',
            content: 'AMA with L1 team regarding spent proposa'
        },
        {
            image: './assets/real_images/events04.png',
            date: '10th of September',
            title: 'Garuda Universe Game Launch',
            content: 'Launch of Game , Garuda the protector '
        },
        {
            image: './assets/real_images/events05.png',
            date: '10th of October ',
            title: 'Luna Classic Shop',
            content: 'Launch of new merchandise line'
        }
    ],
    nfts_top_8: [
        {
            id: 1,
            image: './assets/real_images/nft01.png',
            title: 'Lunc Guardians NFT'
        },
        {
            id: 2,
            image: './assets/real_images/nft02.png',
            title: 'Lunc Legendaries NFT'
        },
        {
            id: 3,
            image: './assets/real_images/nft03.png',
            title: 'Air Force Lunc'
        },
        {
            id: 4,
            image: './assets/real_images/nft04.png',
            title: 'Galactic Shift'
        },
        {
            id: 5,
            image: './assets/real_images/nft05.png',
            title: 'Lunc Dead'
        },
        {
            id: 6,
            image: './assets/real_images/nft06.png',
            title: 'Lunc Fury'
        },
        {
            id: 7,
            image: './assets/real_images/nft07.png',
            title: 'Lunc Ape NFT'
        },
        {
            id: 8,
            image: './assets/real_images/nft08.png',
            title: 'Heroes & Villains'
        },
    ]

};